module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile-body"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-header dvd dvd-btm"
  }, [_c('h1', [_vm._v("Liste des utilisateurs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f73e7102"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/list.vue
// module id = 128
// module chunks = 0